// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"f753c64f","87":"ee341b1d","159":"f80d6676","302":"ccdd0554","319":"65c4a5bc","353":"8f7ad924","446":"08da4633","604":"fbcbccbc","629":"b40c47f0","646":"db214987","732":"771b93c4"}[chunkId] + ".chunk.js";
};